module.exports = __webpack_public_path__ + "static/media/216.c854e711.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/216.jpg
// module id = 958
// module chunks = 0